import { Language } from '@app/models/language';
import { FetchLanguagesSuccess, LanguagesActions, LanguagesActionTypes } from '@app/pcs/actions/language';
import { createHandler, createReducer } from '@util';
import * as R from 'ramda';

export interface State {
  languages: Language[];
}

export const initialState: State = {
  languages: []
};

// Selectors
type GetLanguages = (s: State) => Language[];
export const getLanguages: GetLanguages = R.prop('languages');

// Handlers
const fetchLanguagesSuccess = (state: State, {payload: languages}: FetchLanguagesSuccess): State => R.mergeRight(state, {languages});

const fetchLanguagesSuccessHandler = createHandler(LanguagesActionTypes.FetchLanguagesSuccess, fetchLanguagesSuccess);

export const reducer = createReducer<State, LanguagesActions>([
  fetchLanguagesSuccessHandler
], initialState);
